import 'bootstrap/dist/js/bootstrap.bundle.min.js';
export const onClientEntry = () => {};